import { ContextOption, ContextConfig } from "@/components.generic/context-menu";
import { context } from "@/AppModal";

export const openContextMenu = (e:Event, options:ContextOption[], config?:ContextConfig) => {
	context(e, options, config);
};

export { ContextOption, ContextConfig }